<template>
  <page-wrapper :title="title" :noPadBtm="true">
    <div class="d-flex justify-content-start" style="height: 100%">
      <list-item
        class="col-3 px-0 d-flex flex-column"
        v-model="PackageGroupMainPagePresenter.groups"
        :deletedAt="PackageGroupMainPagePresenter.groups.deletedAt"
        @createCategory="handleCreateCategory"
      ></list-item>
      <div class="col-9 px-0 d-flex flex-column" v-if="isSelectedGroup">
        <item-selector
          v-model="PackageGroupMainPagePresenter.packageGroup.packages"
          :groupName="PackageGroupMainPagePresenter.packageGroup.name"
          :isAffectApp="PackageGroupMainPagePresenter.packageGroup.isAffectApp"
          :allItem="PackageGroupMainPagePresenter.allPackage"
          :deletedAt="PackageGroupMainPagePresenter.packageGroup.deletedAt"
          @selectedItem="handleSelectedItem"
          @removedItem="handleRemovedItem"
          @removedAllItem="handleRemovedAllItem"
          @searchItem="handleSearchItem"
          @updateGroup="handleUpdateGroup"
          @cancelGroup="handleCancelGroup"
        ></item-selector>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ListItem from "@/features/group/components/ListItem";
import ItemSelector from "@/features/group/components/ItemSelector/ItemSelector";
import { isNil } from "ramda";
import { toCamelCaseObject } from "@/lib/util";
import { PackageGroupMainPagePresenter } from "@/presenters/group/package-group/PackageGroupMainPagePresenter";
import { GroupUseCase } from "@/usecases/GroupUseCase";

export default {
  components: {
    PageWrapper,
    ListItem,
    ItemSelector
  },
  data() {
    const title = "Package Group";
    const searchKeyword = "";
    const form = {
      groups: [],
      packageGroup: {
        id: null,
        name: null,
        packages: [],
        isAffectApp: null,
        deletedAt: null
      },
      allPackage: []
    };

    return {
      title,
      form,
      searchKeyword
    };
  },
  watch: {
    $route(newRoute, oldRoute) {
      if (newRoute.path !== oldRoute.path) {
        this.setupPackageGroup();
      }
    }
  },
  created() {
    this.setup();
  },
  computed: {
    PackageGroupMainPagePresenter() {
      const form = {
        ...this.form,
         allPackage: this.filteredPackages
      };

      return new PackageGroupMainPagePresenter(form);
    },
    isSelectedGroup() {
      return !isNil(this.selectedGroupId);
    },
    selectedGroupId() {
      return this.$route.params.id;
    },
    isRJB2BGroupSelected() {
      return this.isSelectedGroup
        ? this.form.groups.some((group) => group.id === this.selectedGroupId && group.name === "RJB2B")
        : false;
    },
    filteredPackages() {
      const searchTerm = this.searchKeyword.toLowerCase();

      return this.form.allPackage.filter((pkg) => {
        const nameMatch = pkg.name.toLowerCase().includes(searchTerm);

        const isPackageGroupsEmpty = pkg.packageGroups.length === 0;
        const isNotRJB2BGroup = pkg.packageGroups.some((group) => group.name !== "RJB2B");

        const packageGroupsMatch = this.isRJB2BGroupSelected
          ? isPackageGroupsEmpty
          : isPackageGroupsEmpty || isNotRJB2BGroup;

        return nameMatch && packageGroupsMatch;
      });
    },
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupGroups();
      this.setupPackageGroup();
      this.setupAllPackage();
    },
    async setupGroups() {
      const groups = await this.fetchGroup();

      this.form.groups = groups;
    },
    async setupPackageGroup() {
      if (!this.selectedGroupId) {
        return;
      }

      const { id, name, packages, isAffectApp, deletedAt } =
        await this.fetchPackageGroup();

      this.form.packageGroup = {
        id,
        name,
        packages: toCamelCaseObject(packages),
        isAffectApp,
        deletedAt
      };
    },
    async setupAllPackage() {
      const allPackage = await this.fetchAllPackage();

      this.form.allPackage = toCamelCaseObject(allPackage);
    },
    async fetchGroup() {
      const groups = await GroupUseCase.list();

      return groups;
    },
    async fetchPackageGroup() {
      const { id } = this.$route.params;
      const packageGroup = await GroupUseCase.getPackageGroup(id);

      return packageGroup;
    },
    async fetchAllPackage() {
      const packages = await GroupUseCase.getAllPackage();

      return packages;
    },
    handleSelectedItem(itemId) {
      const selectedPackage = this.form.allPackage.find(
        (item) => item.id === itemId
      );

      this.form.packageGroup.packages.push(selectedPackage);

      this.form.allPackage.map((pkg) => {
        if (pkg.id === itemId) {
          pkg.packageGroups.push({
            id: this.form.packageGroup.id,
            name: this.form.packageGroup.name
          });
        }

        

        return pkg;
      });
    },
    handleRemovedItem(itemId) {
      this.form.packageGroup = {
        ...this.form.packageGroup,
        packages: this.form.packageGroup.packages.filter(
          (item) => item.id !== itemId
        ),
      };

      this.form.allPackage.map((pkg) => {
        if (pkg.id === itemId) {
          pkg.packageGroups = pkg.packageGroups
            .filter((group) => group.id !== this.form.packageGroup.id);
        }
        

        return pkg;
      });
    },
    handleRemovedAllItem() {
      this.form.packageGroup.packages = [];
    },
    handleSearchItem(keyword) {
      this.searchKeyword = keyword;
    },
    async handleUpdateGroup() {
      try {
        const id = this.form.packageGroup.id;
        const packageIds = this.getPackageIds();

        await GroupUseCase.updatePackageGroup(id, packageIds);

        alert("อัพเดท Group สำเร็จ");
      } catch (error) {
        alert("ไม่สามารถอัพเดท Group ได้ กรุณาลองใหม่อีกครั้ง");
        console.error(error);
      }
    },
    async handleCancelGroup() {
      if (!confirm(`ยืนยันการลบ ${this.form.packageGroup.name}`)) {
        return;
      }

      const packageGroupId = this.form.packageGroup.id;

      await this.cancelGroup(packageGroupId);
    },
    async cancelGroup(packageGroupId) {
      try {
        await GroupUseCase.cancelPackageGroup(packageGroupId);

        await this.setupData();
        alert("ยกเลิก Group สำเร็จ");
      } catch (error) {
        alert("ไม่สามารถยกเลิก Group ได้ กรุณาลองใหม่อีกครั้ง");
        console.error(error);
      }
    },
    getPackageIds() {
      const packageIds = this.form.packageGroup.packages.map((item) =>
        item.id.toString()
      );

      return packageIds;
    },
    async handleCreateCategory(category) {
      await GroupUseCase.post(category);

      this.setupData();
      alert("เพื่มหมวดหมู่เรียบร้อย");
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.header {
  padding: 30px;
  border-bottom: $border;

  background: #f9f9f9;
}

.sc-btn {
  display: inline-block;
  width: auto;
  padding: 6px 20px;
}
</style>



// WEBPACK FOOTER //
// src/features/group/modules/package-group/pages/PackageGroupMainPage.vue